import { useState, useCallback } from "react";
import useFileReader from "./useFileReader";
import ReadFile from "../components/readFile";
import {
  ErrorMessage,
  InfoMessage,
  SuccessMessage,
} from "../../../utils/toastify";
function useFileUpload() {
  const { readProgress, progress, resetProgress } = useFileReader();
  const [data, setData] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [validData, setValidData] = useState([]);
  const [invalidData, setInvalidData] = useState([]);
  const [summary, setSummary] = useState(null);
  const [fileInformation, setFileInformation] = useState(null);
  const [initProcess, setInitProcess] = useState(false);
  const [processing, setProcessing] = useState(false);

  const upload = useCallback(
    async (file) => {
      InfoMessage("Archivo en proceso, por favor espere...");
      try {
        const isValid = await validateFile(file);
        if (!isValid) {
          throw new Error("Invalid file format. Please upload a CSV file.");
        }
        setInitProcess(true);
        await readProgress(file);
        const readFile = new ReadFile(file, {
          onInit: () => {
            setProcessing(true);
          },
          onComplete: () => {
            setProcessing(false);
            SuccessMessage("Archivo procesado correctamente.");
          },
        });
        const {
          allData: data,
          validData: validateData,
          invalidData: invalidateData,
          summary,
        } = await readFile.generate();

        const headersRows = await readFile.headerRows();
        setData(data);
        setValidData(validateData);
        setInvalidData(invalidateData);
        setSummary(summary);
        setHeaders(headersRows);
        setFileInformation({
          name: file.name,
          size: file.size,
          type: file.type,
        });
        setInitProcess(false);
      } catch (error) {
        console.log(error);
        setInitProcess(false);
        ErrorMessage(error.message);
      }
    },

    [readProgress]
  );

  const reset = useCallback(() => {
    setData([]);
    setHeaders([]);
    setFileInformation(null);
    setInitProcess(false);
    resetProgress();
    setValidData();
    setInvalidData([]);
    setSummary(null);
    setProcessing(false);
  }, []);

  return {
    upload,
    data,
    headers,
    progress,
    fileInformation,
    reset,
    initProcess,
    setInitProcess,
    validData,
    invalidData,
    setValidData,
    setInvalidData,
    summary,
    processing,
  };
}

// const fileToBase64 = (file) => {
//   return new Promise((resolve, reject) => {
//     const reader = new FileReader();

//     reader.readAsDataURL(file);

//     reader.onload = () => {
//       const base64 = reader.result.split(",")[1];

//       resolve(base64);
//     };
//     reader.onerror = (error) => reject(error);
//   });

// };

const validateFile = async (file) => {

  let valid = false;

  if (!file) {
    valid = true;
  }

  if (file.type === "text/csv" && file.name.endsWith(".csv")) {
    valid = true;
  }

  if (file.size === 0) {
    valid = false;
  }

  return valid;
};

export default useFileUpload;
